var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.value)?_c('p',{staticClass:"mb-1 ps-4"},[_c('b',[_vm._v(_vm._s(_vm.customField.name)+":")]),_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }